import React, { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import BannerSingle from '../../../BannerSingle';
import PageDescriptionPlano from '../../../PageDescription/Planos/index';
import Lgpd from '../../../Lgpd';
import PatrimonioPlano from '../../../Numeros/Planos';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';

class DescricaoPage extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					<ErrorBoundary><BannerSingle image={"plano-taesaprev"} page={"plano-taesaprev"} /></ErrorBoundary>
					{/* Page description */}
					<ErrorBoundary><PageDescriptionPlano certificado={"/DOCS/Publicacoes/Certificados/TAESAPREV/Certificado%20do%20Participante%20-%20taesaprev.pdf"}  page={'plano-taesaprev'} /></ErrorBoundary>

					{/* Content page */}
					<ErrorBoundary><PatrimonioPlano url={"/ObterDescricaoPlanoTaesaPrev"} urlTable={"/ObterDescricaoPlanoTaesaPrev"}  page={"plano-taesaprev"}/></ErrorBoundary>
					{/* <ErrorBoundary><PatrimonioPlano  url={"/ObterDescricaoPlanoTaesaPrev"} urlTable={"/ObterDescricaoPlanoTaesaPrev"} htmlPart={

						<div className="col-md-10">
							<hr />

							<h3>Percentuais de contribuição</h3>
							<p>
								Níveis de contribuição (%):  50, 75, 90, 100, 125, 150  ou 200 de uma tabela básica aplicada à remuneração do participante. Obs.: a patrocinadora acompanha os mesmos percentuais de contribuição até o teto de 100%. O percentual de contribuição pode ser alterado nos meses de fevereiro, maio, agosto e novembro.
							</p>
							<br />
							<br />

							<h3>Perfis de investimento</h3>
							<p>
								Ultraconservador <br />
								Conservador <br />
								Moderado <br />
								Agressivo
							</p>

							<br />
							<br />

							<h3>Critérios para requerer benefício</h3>
							<ul className="mb-0">
								<li> Estar desligado da patrocinadora; </li>
								<li> Ter pelo menos 8 anos de vínculo com a Forluz; </li>
								<li> Ter, no mínimo, 55 anos de idade.  </li>
							</ul>

							<hr />

							<h3> Modalidades de benefícios </h3>
							<br /> <br />
							<h4> Renda Mensal Programada (RMP) </h4>
							<p>
								O valor da renda é determinado por um percentual entre 0,5% e 1% - à escolha do participante – aplicado ao saldo da conta de aposentadoria. 
							</p>

							<br /> <br />
							<h4> Pecúlio por Invalidez (PPI) </h4>
							<p>
							é o benefício concedido em parcela única pelo plano ao participante que se aposenta por invalidez. Corresponde ao saldo da conta de aposentadoria.
							</p>

							<br /> <br />
							<h4> Pecúlio por Morte (PPM) </h4>
							<p>
							é o benefício pago pelo plano ao(s) beneficiário(s) indicado(s) pelo participante que falece. Corresponde ao saldo da conta de aposentadoria dividido em partes iguais entre os beneficiários.
							</p>

							<br /> <br />


							<div className="desc">
								<h3> Institutos </h3>
								<p>
								Se o participante se desligar da patrocinadora e não tiver cumprido os requisitos exigidos para receber benefício, pode optar por uma das quatro alternativas denominadas "institutos", conforme abaixo:
								</p>
								<br />
								<p>
									<strong> Resgate: </strong> saque da conta individual e uma parcela da conta patronal, conforme o tempo de vinculação ao plano
								</p>
								<br />
								<p>
									<strong> Portabilidade: </strong> transferência para outro plano previdenciário do saldo da conta de aposentadoria.
								</p>
								<br />
								<p>
									<strong> Autopatrocínio: </strong> permanência no plano através do compromisso mensal de verter as contribuições individual e patronal que eram realizadas mensalmente enquanto ativo;
								</p>
								<br />
								<p>
									<strong> BPD (Benefício Proporcional Diferido): </strong> permanência no plano, pagando apenas a contribuição destinada à cobertura das despesas de natureza administrativa. O saldo de conta continua tendo a rentabilidade de acordo com o perfil de investimento escolhido pelo participante.
								</p>
							</div>

						</div>

					} /></ErrorBoundary> */}
					
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default DescricaoPage;